import BaseApi from "./BaseApi";

const baseUrl = 'api/file/';

class FileService {

    static getBlobSas(request:any): Promise<any> {
        return BaseApi.post(`${baseUrl}sasBlob`,request);
    }
}

export default FileService;